module.exports = __webpack_public_path__ + "static/img/news_img.e0ebe127.png";